module.exports = __webpack_public_path__ + "static/media/9-1.ecb27f94.mp3";